import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { fmtArgent, fmtSemaine, LIBELLES_ETATS, CLASSES_ETATS } from '@/lib/lmdsDeductions';

export const BadgeEtat = ({ etat, testid }) => (
  <span className={`inline-block text-xs px-2 py-0.5 rounded-full border ${CLASSES_ETATS[etat] || ''}`} data-testid={testid}>{LIBELLES_ETATS[etat] || etat}</span>
);

// 🧾 Phase 2 : tableau des occurrences avec filtres par état, semaine d'origine / appliquée, montant, règle.
export function TableOccurrences({ occurrences, regles, onAnnuler }) {
  const [filtre, setFiltre] = useState('tous');
  const nomRegle = Object.fromEntries(regles.map((r) => [r.id, r.description]));
  const visibles = occurrences.filter((o) => filtre === 'tous' || o.etat === filtre);
  return (
    <div className="space-y-2">
      <div className="flex flex-wrap gap-1" data-testid="filtres-etats">
        {['tous', ...Object.keys(LIBELLES_ETATS)].map((e) => (
          <Button key={e} size="sm" variant={filtre === e ? 'default' : 'outline'} data-testid={`filtre-etat-${e}`} onClick={() => setFiltre(e)}>
            {e === 'tous' ? 'Tous' : LIBELLES_ETATS[e]} ({e === 'tous' ? occurrences.length : occurrences.filter((o) => o.etat === e).length})
          </Button>
        ))}
      </div>
      {!visibles.length ? <p className="text-sm text-slate-500 p-3" data-testid="occurrences-vide">Aucune occurrence.</p> : (
        <table className="w-full text-sm" data-testid="table-occurrences">
          <thead className="text-xs text-slate-500 text-left">
            <tr><th className="p-2">Règle</th><th className="p-2">Semaine d'origine</th><th className="p-2">Semaine appliquée</th><th className="p-2 text-right">Montant</th><th className="p-2">État</th><th className="p-2"></th></tr>
          </thead>
          <tbody>
            {visibles.map((o) => (
              <tr key={o.id} className="border-t" data-testid={`occurrence-${o.id}`}>
                <td className="p-2">{o.description || nomRegle[o.regle_id]}{o.report_de && <span className="ml-1 text-xs text-violet-700">(report)</span>}</td>
                <td className="p-2">{fmtSemaine(o.semaine_origine)}</td>
                <td className="p-2">{fmtSemaine(o.semaine_appliquee)}{o.gele && <span className="ml-1 text-xs text-slate-500">· payée</span>}</td>
                <td className="p-2 text-right">{fmtArgent(o.total)}</td>
                <td className="p-2"><BadgeEtat etat={o.etat} testid={`occurrence-etat-${o.id}`} /></td>
                <td className="p-2 text-right">
                  {['a_venir', 'en_attente'].includes(o.etat) && (
                    <Button size="sm" variant="ghost" className="text-red-700" data-testid={`occurrence-annuler-${o.id}`} onClick={() => onAnnuler(o)}>Annuler</Button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
